import { useContext } from 'react';
import { AppContext } from '../../../../../AppContext';
import ModalComponent from '../../../../../components/ModalComponent';

const DelayReasonModal = ({ note, isModalOpen, setIsModalOpen }) => {
  const { getCurrentUser } = useContext(AppContext);
  const { roles } = getCurrentUser() || {};
  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={() => {
        setIsModalOpen(false);
      }}
      footer={null}
    >
      {note && (
        <>
          <div className="mb-8">
            <b className="font-size-16">Note By Library</b>
            <div className="font-size-16">
              Reason for delay in fulfilling the order:-{' '}
              {note?.delayReason?.value || '-'}
            </div>

            <div className="font-size-16">
              Note:- {note?.delayNote?.value || '-'}
            </div>
          </div>
        </>
      )}
    </ModalComponent>
  );
};

export default DelayReasonModal;
